// extracted by mini-css-extract-plugin
export default {"status_bar":"deviceStatusBar_status_bar__QCqmG","status_bar_left":"deviceStatusBar_status_bar_left__VrnGz","status_bar_right":"deviceStatusBar_status_bar_right__wc3B4"};